import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/Dialog';
import { Button } from '@/components/wm';
import React, { cloneElement, isValidElement, useState } from 'react';

const ManageLicense = ({ description, model, onClose, mode = 'edit', children, title }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});

    const initializeFormData = () => {
        React.Children.forEach(children, child => {
            if (isValidElement(child)) {
                const { property, value } = child.props;
                if (property && value !== undefined) {
                    setFormData(prev => ({ ...prev, [property]: value }));
                }
            }
        });
    };

    React.useEffect(() => {
        initializeFormData();
    }, []);

    const handleInputChange = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }));
    };

    const handleSave = async e => {
        e.preventDefault();

        const backboneModel = mode === 'edit' ? WiseMetering.integrationLicenses.get(model.id) : new WiseMetering.Model.IntegrationLicense();

        setLoading(true);

        try {
            await backboneModel.addLicenses(formData, { wait: true, patch: true });

            if (mode === 'create') {
                WiseMetering.integrationLicenses.add(backboneModel);
            }

            WiseMetering.layout.showTipper('success', i18next.t('ui.successfully_saved'));
            setFormData({});
            onClose();
        } catch (err) {
            const errors = err.responseJSON || null;
            let errorMessage = '';

            if (errors) {
                Object.entries(errors).forEach(([key, value]) => {
                    if (typeof value === 'string') {
                        errorMessage += `${key.capitalize()}: ${value.capitalize()} <br>`;
                    } else {
                        Object.entries(value).forEach(([nestedKey, nestedValue]) => {
                            errorMessage += `${nestedKey.capitalize()}: ${nestedValue.capitalize()} <br>`;
                        });
                    }
                });
            } else {
                errorMessage = 'An error occurred';
            }

            WiseMetering.layout.showTipper('error', errorMessage);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    if (title === null || title === undefined) {
        title = mode === 'create' ? i18next.t('common.create').capitalize() : i18next.t('common.update').capitalize();
    }

    return (
        <Dialog onOpenChange={onClose} open={true}>
            <DialogContent className="tailwind-container">
                <DialogHeader>
                    <DialogTitle>
                        {title}
                    </DialogTitle>
                    {description && <DialogDescription>{description}</DialogDescription>}
                </DialogHeader>
                <div className="tw-space-y-4">
                    {React.Children.map(children, child => {
                        if (isValidElement(child)) {
                            const props = child.props, key = props.property;

                            return cloneElement(child, {
                                dataType: props.dataType,
                                value: props.value || formData[key] || '',
                                onChange: value => handleInputChange(key, value),
                                type: props.type
                            });
                        }

                        return child;
                    })}
                </div>
                <DialogFooter>
                    <Button onClick={onClose} variant="ghost">
                        {i18next.t('ui.buttons.cancel')}
                    </Button>
                    <Button loading={loading} onClick={handleSave}>
                        {i18next.t('ui.buttons.submit')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export { ManageLicense };
